import classes from './TitleLine.module.css';

const TitleLine = () => {
    return (
        <div className={classes.titleLine} />
    )
};

export default TitleLine;